import { fetchRequest } from "../helpers/Utils";
import { setShowMessageObj } from "../store/userSlice";

export const getAllGuides = async (params) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `/guides?${queryString}`;
    
    const response = await fetchRequest('GET', url);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const getAllGoogleMapGuides = async () => {
  try {
    const response = await fetchRequest('GET', '/guides/cities/all');
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const getGuides = async (guidesId, dispatch) => {
  try {
    const res = await fetchRequest('GET', '/guides/' + guidesId);
    if (res?.id?.length) {
      return res;
    } else {
      dispatch(setShowMessageObj({ open: true, status: 'error', message: res || 'Failed to get guides' }));
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    dispatch(setShowMessageObj({ open: true, status: 'error', message: 'Failed to get guides' }));
    return null;
  }
}

export const bookGuides = async (guidesId, data) => {
  try {
    const response = await fetchRequest('POST', `/guides/${guidesId}/book`, data);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

export const getBookedGuides = async (guidesId) => {
  try {
    const res = await fetchRequest('GET', '/bookings/' + guidesId);
    if (res?.id?.length) {
      return res;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}